import { render } from "./ProjectTitle.vue?vue&type=template&id=353ee627&scoped=true"
import script from "./ProjectTitle.vue?vue&type=script&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&lang=js"

import "./ProjectTitle.vue?vue&type=style&index=0&id=353ee627&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353ee627"]])

export default __exports__